<template>
  <div>
    <div class="workOrder_info">
      <div class="center" v-show="info.state == 3 ? true : false">
        <el-steps :active="5" align-center>
          <el-step
            title="建单"
            :description="info.createTime"
            icon="el-icon-add-location"
          ></el-step>
          <el-step
            title="响应时间"
            :description="responseTime"
            icon="el-icon-time"
            style="color: red"
          ></el-step>
          <el-step
            title="处理"
            :description="info.receiveTime"
            icon="el-icon-refresh-right"
          ></el-step>
          <el-step
            title="处理时间"
            :description="handlingTime"
            icon="el-icon-time"
          ></el-step>
          <el-step
            title="完成"
            :description="info.finishTime"
            icon="el-icon-circle-check"
          ></el-step>
        </el-steps>
        <!--  <p class="elp elp1">{{ responseTime }}</p>
        <p class="elp elp2">{{ handlingTime }}</p> -->
      </div>
      <div class="right" style="margin-right: 10px">
        <h1 class="common_color1" v-if="info.state === 1 && info.sendType == 3">
          待抢单
        </h1>
        <h1 class="common_color1" v-if="info.state === 1 && info.sendType != 3">
          待处理
        </h1>
        <h1 class="common_color2" v-if="info.state === 2">处理中</h1>
        <h1 class="common_color2" v-if="info.state === 4">挂起中</h1>
        <h1 class="common_color3" v-if="info.state === 3">
          {{ handlingTime2 }}
        </h1>
      </div>
    </div>
    <el-divider class="divider"></el-divider>
    <div class="bottom">
      <div class="Bleft">
        <Form ref="formDynamic" :model="formDynamic" :label-width="80">
          <List border size="small">
            <ListItem>
              <Col span="3">工单编号:</Col>
              <Col span="19">{{ info.workNo }}</Col>
            </ListItem>
            <ListItem>
              <Col span="3">工单类型:</Col>
              <Col span="19">{{ info.typeName }}</Col>
            </ListItem>
            <ListItem>
              <Col span="3">报修位置:</Col>
              <Col span="19"
                >{{ info.deskName
                }}{{ info.facilitySite ? "-" + info.facilitySite : null }}</Col
              >
            </ListItem>
            <ListItem v-show="info.isFastOrder == 1 ? false : true">
              <Col span="3"> 设备编号:</Col>
              <Col span="19" style="color: #409eff; cursor: pointer">
                <p @click="toInfo2(assetId)" v-if="customerId != 0">
                  {{ assetNum }}
                </p>
                <p v-else>{{ assetNum }}</p>
              </Col>
            </ListItem>
            <ListItem v-show="info.facilityName ? true : false">
              <Col span="3">设备名称:</Col>
              <Col span="19">{{ info.facilityName }}</Col>
            </ListItem>
            <ListItem v-show="info.recordFile ? true : false">
              <Col span="3">录音文件:</Col>
              <Col span="19">
                <p class="play" @click="toplay(info.recordFile)">播放</p>
              </Col>
            </ListItem>
            <ListItem v-show="info.expensesIncurred == 0 ? false : true">
              <Col span="3">产生费用:</Col>
              <Col span="19">{{ info.expensesIncurred }}</Col>
            </ListItem>
            <ListItem
              v-show="info.consumableName && info.consumableNum ? true : false"
            >
              <Col span="3">产生耗材:</Col>
              <Col span="19">
                {{ info.consumableName }}*{{ info.consumableNum }}
              </Col>
            </ListItem>
          </List>
          <!-- 表格 -->
          <Row :gutter="5" v-show="info.isFastOrder == 1 ? false : true">
            <h4 style="margin: 10px 0">设备信息:</h4>
            <Col span="24">
              <Table
                :columns="tableCols"
                :data="tabledata"
                :table="table"
                :border="table.border"
                :stripe="table.stripe"
                :header="table.header"
                :footer="table.footer"
                :columns-list="tableCols"
              >
              </Table>
            </Col>
          </Row>
        </Form>
      </div>
      <div class="Bright">
        <el-timeline>
          <!-- 待处理 -->
          <div v-if="info.state === 1">
            <el-timeline-item
              :timestamp="info.createTime"
              placement="top"
              size="large"
              color="#fe7a24"
              icon="el-icon-more-outline"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.repairAvatar
                        ? info.repairAvatar.includes('http')
                          ? info.repairAvatar
                          : IMAGE_HOST + info.repairAvatar
                        : info.repairAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div style="width: 80%">
                    <h3>{{ info.repairName }}创建工单</h3>
                    <span>报修时间: {{ info.createTime }}</span>
                    <p style="height: 10px"></p>
                    <p>信息来源: {{ text }}</p>
                    <p v-show="repairName">报修人: {{ repairName }}</p>
                    <p>报修电话: {{ callno || repairPhone || "暂无电话" }}</p>
                    <p>工单类型: {{ oldType }}</p>
                    <p>
                      派单方式:
                      {{ sendTypeName }}
                    </p>
                    <p v-show="info.maintainerName == null ? false : true">
                      指派接单: {{ info.maintainerName }}
                    </p>
                    <div v-show="info.descr == null ? false : true">
                      <p>报修内容: {{ info.descr }}</p>
                      <div>
                        <audio
                          style="height: 25px; width: 280px"
                          controls="controls"
                          :src="info.voiceUrl"
                          ref="audio"
                          v-show="info.voiceUrl ? true : false"
                        ></audio>
                        &nbsp;
                        <el-image
                          v-for="item in info.imgUrl"
                          :key="item"
                          style="width: 50px; height: 50px; margin-left: 5px"
                          :src="item"
                          :initial-index="0"
                          fit="cover"
                          v-show="item ? true : false"
                          :preview-src-list="previewSrcList(item)"
                        >
                          <div slot="error" class="image-slot">
                            <img src="../../assets/img/pictureSplit.png" />
                          </div>
                        </el-image>
                      </div>
                    </div>
                    <div v-show="oldname ? true : false">
                      <p>
                        {{ createTime }} <i class="el-icon-d-arrow-right"></i>
                        {{ oldname }}将工单转给{{ newname }}
                      </p>
                      <p v-show="block">
                        {{ updateTime }} <i class="el-icon-d-arrow-right"></i>
                        {{ newname }}{{ remark }}{{ oldname }}转派的工单
                      </p>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
          </div>

          <!-- 处理中 -->
          <div v-if="info.state === 2">
            <el-timeline-item
              :timestamp="info.receiveTime"
              placement="top"
              size="large"
              color="#fe7a24"
              icon="el-icon-more-outline"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.maintainerAvatar
                        ? info.maintainerAvatar.includes('http')
                          ? info.maintainerAvatar
                          : IMAGE_HOST + info.maintainerAvatar
                        : info.maintainerAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div style="width: 80%">
                    <h3>工单处理中</h3>
                    <div v-for="item in data2" :key="item">
                      <p>
                        {{ item.createTime }}
                        <i class="el-icon-d-arrow-right"></i>
                        {{ maintainerName }}邀请{{
                          item.maintainerName
                        }}作为协同维修员
                      </p>
                      <p>
                        {{ item.updateTime }}
                        <i class="el-icon-d-arrow-right"></i>
                        {{ item.maintainerName
                        }}{{
                          item.synergyState == 1
                            ? "待确认"
                            : item.synergyState == 2
                            ? "已拒绝"
                            : item.synergyState == 3 || item.synergyState == 4
                            ? "已接受"
                            : ""
                        }}{{ maintainerName }}的协同工单
                      </p>
                    </div>
                    <div v-for="item in sysWorkTracks" :key="item">
                      <div>
                        <div v-show="item.type == 2 ? true : false">
                          <div style="height: 10px"></div>
                          <p v-show="item.workState == 2 ? true : false">
                            {{ item.suspensionTime }}
                            <i class="el-icon-d-arrow-right"></i>
                            {{ item.maintainerName }}填写维修记录:{{
                              item.workContent
                            }}
                          </p>
                        </div>
                        <p v-show="item.workState == 2 ? true : false">
                          {{ item.maintainerName }}修改状态为维修中
                        </p>
                      </div>
                      <div v-show="item.suspensionEndTime ? true : false">
                        <div style="height: 10px"></div>
                        <span>处理时间: {{ item.suspensionEndTime }}</span>
                        <p>{{ item.maintainerName }}结束挂起状态</p>
                      </div>
                      <div v-show="item.type == 1 ? true : false">
                        <div style="height: 10px"></div>
                        <p>{{ item.maintainerName }}已挂起工单</p>
                        <span>挂起时间: {{ item.suspensionTime }}</span>
                        <p>挂起原因:{{ item.workContent }}</p>
                      </div>
                      <p
                        v-show="
                          item.workState == 2 &&
                          item.handleType == 4 &&
                          item.sendTime
                        "
                      >
                        寄修时间：{{ item.sendTime }}
                      </p>
                      <p
                        v-show="
                          item.changeTypeId == null ||
                          item.changeTypeId == 0 ||
                          item.workState == 3
                            ? false
                            : true
                        "
                      >
                        {{ item.maintainerName }}变更工单类型为:{{
                          item.changeTypeId
                        }}
                      </p>
                      <el-image
                        v-for="src in item.imgUrl"
                        :key="src"
                        style="width: 50px; height: 50px; margin-left: 5px"
                        :src="src"
                        :initial-index="0"
                        fit="cover"
                        :preview-src-list="previewSrcList(src)"
                        v-show="src && item.workState == 2 ? true : false"
                      >
                        <div slot="error" class="image-slot">
                          <img src="../../assets/img/pictureSplit.png" />
                        </div>
                      </el-image>
                    </div>
                    <div style="height: 10px"></div>
                    <p>{{ maintainerName }}已接单</p>
                    <p>接单时间: {{ info.receiveTime }}</p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              :timestamp="info.createTime"
              placement="top"
              size="large"
              color="#11d169"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.repairAvatar
                        ? info.repairAvatar.includes('http')
                          ? info.repairAvatar
                          : IMAGE_HOST + info.repairAvatar
                        : info.repairAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div style="width: 80%">
                    <h3>{{ info.repairName }}创建工单</h3>
                    <span>报修时间: {{ info.createTime }}</span>
                    <p style="height: 10px"></p>
                    <p>信息来源: {{ text }}</p>
                    <p v-show="repairName">报修人: {{ repairName }}</p>
                    <p>报修电话: {{ callno || repairPhone || "暂无电话" }}</p>
                    <p>工单类型: {{ oldType }}</p>
                    <p>
                      派单方式:
                      {{ sendTypeName }}
                    </p>
                    <p v-show="info.maintainerName == null ? false : true">
                      指派接单: {{ info.maintainerName }}
                    </p>
                    <div v-show="info.descr == null ? false : true">
                      <p>报修内容: {{ info.descr }}</p>
                      <div>
                        <audio
                          style="height: 25px; width: 280px"
                          controls="controls"
                          :src="info.voiceUrl"
                          ref="audio"
                          v-show="info.voiceUrl ? true : false"
                        ></audio>
                        &nbsp;
                        <el-image
                          v-for="item in info.imgUrl"
                          :key="item"
                          style="width: 50px; height: 50px; margin-left: 5px"
                          :src="item"
                          :initial-index="0"
                          fit="cover"
                          :preview-src-list="previewSrcList(item)"
                          v-show="item ? true : false"
                        >
                          <div slot="error" class="image-slot">
                            <img src="../../assets/img/pictureSplit.png" />
                          </div>
                        </el-image>
                      </div>
                    </div>
                    <div v-show="oldname ? true : false">
                      <p>
                        {{ createTime }} <i class="el-icon-d-arrow-right"></i>
                        {{ oldname }}将工单转给{{ newname }}
                      </p>
                      <p v-show="block">
                        {{ updateTime }} <i class="el-icon-d-arrow-right"></i>
                        {{ newname }}{{ remark }}{{ oldname }}转派的工单
                      </p>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
          </div>

          <!-- 已完成 -->
          <div v-if="info.state === 3">
            <el-timeline-item
              :timestamp="info.finishTime"
              placement="top"
              size="large"
              color="#11d169"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.maintainerAvatar
                        ? info.maintainerAvatar.includes('http')
                          ? info.maintainerAvatar
                          : IMAGE_HOST + info.maintainerAvatar
                        : info.maintainerAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div style="width: 80%">
                    <h3>工单已完成</h3>
                    <span>完成时间: {{ info.finishTime }}</span>
                    <p style="height: 10px"></p>
                    <div v-for="item in sysWorkTracks" :key="item">
                      <p v-show="item.workState == 3 ? true : false">
                        {{ item.maintainerName }}修改状态为已完成
                      </p>
                      <p
                        v-show="
                          item.workState == 3 &&
                          item.handleType == 4 &&
                          item.receiveTime
                        "
                      >
                        收货时间：{{ item.receiveTime }}
                      </p>
                      <p
                        v-show="
                          item.workState == 3 &&
                          (item.handleType == 4 || item.handleType == 3) &&
                          item.returnTime
                        "
                      >
                        送回时间：{{ item.returnTime }}
                      </p>
                      <p v-show="item.workState == 3 ? true : false">
                        {{ item.suspensionTime }}
                        <i class="el-icon-d-arrow-right"></i>
                        {{ item.maintainerName }}填写维修记录:{{
                          item.workContent
                        }}
                      </p>
                      <el-image
                        v-for="src in item.imgUrl"
                        :key="src"
                        style="width: 50px; height: 50px; margin-left: 5px"
                        :src="src"
                        :initial-index="0"
                        fit="cover"
                        :preview-src-list="previewSrcList(src)"
                        v-show="src && item.workState == 3 ? true : false"
                      >
                        <div slot="error" class="image-slot">
                          <img src="../../assets/img/pictureSplit.png" />
                        </div>
                      </el-image>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              :timestamp="info.receiveTime"
              placement="top"
              size="large"
              color="#11d169"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.maintainerAvatar
                        ? info.maintainerAvatar.includes('http')
                          ? info.maintainerAvatar
                          : IMAGE_HOST + info.maintainerAvatar
                        : info.maintainerAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div style="width: 80%">
                    <h3>工单处理中</h3>
                    <div v-for="item in data2" :key="item">
                      <p>
                        {{ item.createTime }}
                        <i class="el-icon-d-arrow-right"></i>
                        {{ maintainerName }}邀请{{
                          item.maintainerName
                        }}作为协同维修员
                      </p>
                      <p>
                        {{ item.updateTime }}
                        <i class="el-icon-d-arrow-right"></i>
                        {{ item.maintainerName
                        }}{{
                          item.synergyState == 1
                            ? "待确认"
                            : item.synergyState == 2
                            ? "已拒绝"
                            : item.synergyState == 3 || item.synergyState == 4
                            ? "已接受"
                            : ""
                        }}{{ maintainerName }}的协同工单
                      </p>
                    </div>
                    <div v-for="item in sysWorkTracks" :key="item">
                      <div>
                        <div v-show="item.type == 2 ? true : false">
                          <div style="height: 10px"></div>
                          <p v-show="item.workState == 2 ? true : false">
                            {{ item.suspensionTime }}
                            <i class="el-icon-d-arrow-right"></i>
                            {{ item.maintainerName }}填写维修记录:{{
                              item.workContent
                            }}
                          </p>
                        </div>
                        <p v-show="item.workState == 2 ? true : false">
                          {{ item.maintainerName }}修改状态为维修中
                        </p>
                      </div>
                      <div v-show="item.suspensionEndTime ? true : false">
                        <div style="height: 10px"></div>
                        <span>处理时间: {{ item.suspensionEndTime }}</span>
                        <p>{{ item.maintainerName }}结束挂起状态</p>
                      </div>
                      <div v-show="item.type == 1 ? true : false">
                        <div style="height: 10px"></div>
                        <p>{{ item.maintainerName }}已挂起工单</p>
                        <span>挂起时间: {{ item.suspensionTime }}</span>
                        <p>挂起原因:{{ item.workContent }}</p>
                      </div>
                      <p
                        v-show="
                          item.workState == 2 &&
                          item.handleType == 4 &&
                          item.sendTime
                        "
                      >
                        寄修时间：{{ item.sendTime }}
                      </p>
                      <p
                        v-show="
                          item.changeTypeId == null ||
                          item.changeTypeId == 0 ||
                          item.workState == 3
                            ? false
                            : true
                        "
                      >
                        {{ item.maintainerName }}变更工单类型为:{{
                          item.changeTypeId
                        }}
                      </p>
                      <el-image
                        v-for="src in item.imgUrl"
                        :key="src"
                        style="width: 50px; height: 50px; margin-left: 5px"
                        :src="src"
                        :initial-index="0"
                        fit="cover"
                        :preview-src-list="previewSrcList(src)"
                        v-show="src && item.workState == 2 ? true : false"
                      >
                        <div slot="error" class="image-slot">
                          <img src="../../assets/img/pictureSplit.png" />
                        </div>
                      </el-image>
                    </div>
                    <div style="height: 10px"></div>
                    <p>{{ maintainerName }}已接单</p>
                    <p>接单时间: {{ info.receiveTime }}</p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              :timestamp="info.createTime"
              placement="top"
              size="large"
              color="#11d169"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.repairAvatar
                        ? info.repairAvatar.includes('http')
                          ? info.repairAvatar
                          : IMAGE_HOST + info.repairAvatar
                        : info.repairAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div style="width: 80%">
                    <h3>{{ info.repairName }}创建工单</h3>
                    <span>报修时间: {{ info.createTime }}</span>
                    <p style="height: 10px"></p>
                    <p>信息来源: {{ text }}</p>
                    <p v-show="repairName">报修人: {{ repairName }}</p>
                    <p>报修电话: {{ callno || repairPhone || "暂无电话" }}</p>
                    <p>工单类型: {{ oldType }}</p>
                    <p>
                      派单方式:
                      {{ sendTypeName }}
                    </p>
                    <p v-show="info.maintainerName == null ? false : true">
                      指派接单: {{ info.maintainerName }}
                    </p>
                    <div v-show="info.descr == null ? false : true">
                      <p>报修内容: {{ info.descr }}</p>
                      <div>
                        <audio
                          style="height: 25px; width: 280px"
                          controls="controls"
                          :src="info.voiceUrl"
                          ref="audio"
                          v-show="info.voiceUrl ? true : false"
                        ></audio>
                        &nbsp;
                        <el-image
                          v-for="item in info.imgUrl"
                          :key="item"
                          style="width: 50px; height: 50px; margin-left: 5px"
                          :src="item"
                          :initial-index="0"
                          fit="cover"
                          :preview-src-list="previewSrcList(item)"
                          v-show="item ? true : false"
                        >
                          <div slot="error" class="image-slot">
                            <img src="../../assets/img/pictureSplit.png" />
                          </div>
                        </el-image>
                      </div>
                    </div>
                    <div v-show="oldname ? true : false">
                      <p>
                        {{ createTime }} <i class="el-icon-d-arrow-right"></i>
                        {{ oldname }}将工单转给{{ newname }}
                      </p>
                      <p v-show="block">
                        {{ updateTime }} <i class="el-icon-d-arrow-right"></i>
                        {{ newname }}{{ remark }}{{ oldname }}转派的工单
                      </p>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
          </div>

          <!-- 挂起中 -->
          <div v-if="info.state === 4">
            <el-timeline-item
              :timestamp="info.receiveTime"
              placement="top"
              size="large"
              color="#fe7a24"
              icon="el-icon-more-outline"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.maintainerAvatar
                        ? info.maintainerAvatar.includes('http')
                          ? info.maintainerAvatar
                          : IMAGE_HOST + info.maintainerAvatar
                        : info.maintainerAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div style="width: 80%">
                    <h3>工单挂起中</h3>
                    <div v-for="item in data2" :key="item">
                      <p>
                        {{ item.createTime }}
                        <i class="el-icon-d-arrow-right"></i>
                        {{ maintainerName }}邀请{{
                          item.maintainerName
                        }}作为协同维修员
                      </p>
                      <p>
                        {{ item.updateTime }}
                        <i class="el-icon-d-arrow-right"></i>
                        {{ item.maintainerName
                        }}{{
                          item.synergyState == 1
                            ? "待确认"
                            : item.synergyState == 2
                            ? "已拒绝"
                            : item.synergyState == 3 || item.synergyState == 4
                            ? "已接受"
                            : ""
                        }}{{ maintainerName }}的协同工单
                      </p>
                    </div>
                    <div v-for="item in sysWorkTracks" :key="item">
                      <div>
                        <div v-show="item.type == 2 ? true : false">
                          <div style="height: 10px"></div>
                          <p>
                            {{ item.suspensionTime }}
                            <i class="el-icon-d-arrow-right"></i>
                            {{ item.maintainerName }}填写维修记录:{{
                              item.workContent
                            }}
                          </p>
                        </div>
                        <p v-show="item.workState == 2 ? true : false">
                          {{ item.maintainerName }}修改状态为维修中
                        </p>
                        <p v-show="item.workState == 3 ? true : false">
                          {{ item.maintainerName }}修改状态为已完成
                        </p>
                      </div>
                      <div v-show="item.suspensionEndTime ? true : false">
                        <div style="height: 10px"></div>
                        <span>处理时间: {{ item.suspensionEndTime }}</span>
                        <p>{{ item.maintainerName }}结束挂起状态</p>
                      </div>
                      <div v-show="item.type == 1 ? true : false">
                        <div style="height: 10px"></div>
                        <p>{{ item.maintainerName }}已挂起工单</p>
                        <span>挂起时间: {{ item.suspensionTime }}</span>
                        <p>挂起原因:{{ item.workContent }}</p>
                      </div>
                      <p
                        v-show="
                          item.workState == 2 &&
                          item.handleType == 4 &&
                          item.sendTime
                        "
                      >
                        寄修时间：{{ item.sendTime }}
                      </p>
                      <p
                        v-show="
                          item.changeTypeId == null ||
                          item.changeTypeId == 0 ||
                          item.workState == 3
                            ? false
                            : true
                        "
                      >
                        {{ item.maintainerName }}变更工单类型为:{{
                          item.changeTypeId
                        }}
                      </p>
                      <el-image
                        v-for="item in item.imgUrl"
                        :key="item"
                        style="width: 50px; height: 50px; margin-left: 5px"
                        :src="item"
                        :initial-index="0"
                        fit="cover"
                        :preview-src-list="previewSrcList(item)"
                        v-show="item ? true : false"
                      >
                        <div slot="error" class="image-slot">
                          <img src="../../assets/img/pictureSplit.png" />
                        </div>
                      </el-image>
                    </div>
                    <div style="height: 10px"></div>
                    <p>{{ maintainerName }}已接单</p>
                    <p>接单时间: {{ info.receiveTime }}</p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              :timestamp="info.createTime"
              placement="top"
              size="large"
              color="#11d169"
              icon="el-icon-circle-check"
            >
              <el-card>
                <div style="display: flex">
                  <el-avatar
                    style="margin-right: 10px"
                    shape="circle"
                    :size="50"
                    :src="
                      info.repairAvatar
                        ? info.repairAvatar.includes('http')
                          ? info.repairAvatar
                          : IMAGE_HOST + info.repairAvatar
                        : info.repairAvatar
                    "
                    @error="errorHandler"
                  >
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div style="width: 80%">
                    <h3>{{ info.repairName }}创建工单</h3>
                    <span>报修时间: {{ info.createTime }}</span>
                    <p style="height: 10px"></p>
                    <p>信息来源: {{ text }}</p>
                    <p v-show="repairName">报修人: {{ repairName }}</p>
                    <p>报修电话: {{ callno || repairPhone || "暂无电话" }}</p>
                    <p>工单类型: {{ oldType }}</p>
                    <p>
                      派单方式:
                      {{ sendTypeName }}
                    </p>
                    <p v-show="info.maintainerName == null ? false : true">
                      指派接单: {{ info.maintainerName }}
                    </p>
                    <div v-show="info.descr == null ? false : true">
                      <p>报修内容: {{ info.descr }}</p>
                      <div>
                        <audio
                          style="height: 25px; width: 280px"
                          controls="controls"
                          :src="info.voiceUrl"
                          ref="audio"
                          v-show="info.voiceUrl ? true : false"
                        ></audio>
                        &nbsp;
                        <el-image
                          v-for="item in info.imgUrl"
                          :key="item"
                          style="width: 50px; height: 50px; margin-left: 5px"
                          :src="item"
                          :initial-index="0"
                          fit="cover"
                          :preview-src-list="previewSrcList(item)"
                          v-show="item ? true : false"
                        >
                          <div slot="error" class="image-slot">
                            <img src="../../assets/img/pictureSplit.png" />
                          </div>
                        </el-image>
                      </div>
                    </div>
                    <div v-show="oldname ? true : false">
                      <p>
                        {{ createTime }} <i class="el-icon-d-arrow-right"></i>
                        {{ oldname }}将工单转给{{ newname }}
                      </p>
                      <p v-show="block">
                        {{ updateTime }} <i class="el-icon-d-arrow-right"></i>
                        {{ newname }}{{ remark }}{{ oldname }}转派的工单
                      </p>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
          </div>
        </el-timeline>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { IMAGE_HOST } from "../../../config";
import logo from "../../assets/logo.png";
const customerId = window.localStorage.getItem("customerId");

export default {
  name: "orderInfo",
  components: { ElImageViewer },
  props: {
    kv: null,
    workId: {
      type: String,
      value: "",
    },
    callId: {
      type: String,
      value: "",
    },
  },
  watch: {
    kv(v) {},
  },
  data() {
    return {
      customerId: customerId,
      Pendinglist: [], //工单挂起记录
      text: "",
      IMAGE_HOST: IMAGE_HOST,
      mname: "work",
      url: "",
      items: [], // 显示条目
      info: {},
      imgUrl: "",
      sendTypeName: "",
      imgVisible: false,
      imgVisibles: false,
      list: [],
      id: "",
      synergyState: "", //?是否协同工单
      // synergyList:[],  //?协同工单人员
      data1: [],
      data2: [],
      total: this.total,
      imgUrls: [],
      showViewer: false,
      guidePic: null, // 预览图片的地址
      oldname: "", //原维修员名字
      newname: "", //新维修员名字
      remark: "", //转单结果
      createTime: "", //转单时间
      updateTime: "", //接受转单时间
      block: false,
      sysWorkTracks: [], //维修记录
      maintainerName: "",
      oldType: "", //原始工单类型
      responseTime: "", //响应时间
      handlingTime: "", //处理时间
      handlingTime2: "", //总处理时间
      assetNum: "", //设备编号
      facilityNo: "", //系统编号
      assetId: "", //设备ID
      tabledata: [],
      callno: "",
      repairName: "",
      repairPhone: "",
      table: {
        mname: "consumables",
        key: "id",
        url: {},
        output: false,
        border: true,
        rows: [],
        stripe: true,
        header: false,
        footer: false,
        order: "",
        router: {
          add: "",
          edit: "",
        },
      },
      tableCols: [
        {
          title: "图片",
          minWidth: 80,
          align: "center",
          render: (h, p) => {
            return h("div", [
              h("img", {
                style: {
                  width: "60px",
                  height: "60px",
                },
                attrs: {
                  src:
                    p.row.facilityImg == "" || p.row.facilityImg == null
                      ? logo
                      : p.row.facilityImg,
                },
              }),
            ]);
          },
        },
        {
          title: "设备编号",
          key: "assetNum",
          minWidth: 160,
          align: "center",
          copy: true,
        },
        {
          title: "使用科室",
          key: "deskName",
          minWidth: 120,
          align: "center",
          tooltip: "true",
        },
        {
          title: "名称",
          key: "facilityName",
          minWidth: 200,
          align: "center",
        },
        {
          title: "品牌",
          minWidth: 120,
          align: "center",
          key: "facilityBrand",
          tooltip: "true",
        },
        {
          title: "型号",
          minWidth: 120,
          align: "center",
          key: "facilityType",
          tooltip: "true",
        },
        {
          title: "状态",
          minWidth: 80,
          align: "center",
          key: "state",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.state == 1
                ? "库存中"
                : row.state == 2
                ? "使用中"
                : row.state == 3
                ? "已损坏"
                : row.state == 4
                ? "已报废"
                : row.state == 5
                ? "备用库"
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
      ],
    };
  },
  created() {
    let route = this.$route;
    this.title = route.title || "";
    let query = this.$route.query;
    if (query.kv) {
      this.kv = query.kv;
    }
    if (this.kv) {
      this.initData(this.kv);
    }
    if (this.workId) {
      this.initData(this.workId);
    }
    if (query.callId) {
      this.callId = query.callId;
      this.initData(query.callId);
    }
    if (query.stateId) {
      this.editInformation(query.stateId);
    }
  },
  methods: {
    async editInformation(id) {
      let d = {
        id: id,
      };
      let res = await $utils.api.load("/admin/system/information", d, "PUT");
    },
    initData(workId, page = 1) {
      // 加载详情工单数据
      let id = this.kv;
      let callId = this.callId;
      if (callId == null) {
        $utils.api.load(`/admin/system/work/${id}`, {}).then((res) => {
          if (res && res.data) {
            this.callno = res.data.callno;
            this.repairPhone = res.data.repairPhone;
            this.repairName = res.data.repairName;
            if (res.data.isFastOrder != 1 && res.data.facilityNo != null) {
              this.toInfo(res.data.facilityNo);
            }
            this.Pendinglist =
              res.data.sysWorkSuspensionList != null &&
              res.data.sysWorkSuspensionList != []
                ? res.data.sysWorkSuspensionList
                : null;
            let Pendingtime = "";
            if (res.data.state == 3 && this.Pendinglist != null) {
              Pendingtime = this.calculateTimeDifferences(this.Pendinglist);
            }
            this.info = res.data;
            let img = res.data.imgUrl;
            if (img && img.includes('imgUrl:""')) {
              console.log("No image URLs found");
            } else {
              if (img && img.includes(",")) {
                let img_urls = img.split(",");
                let imgUrlArr = [];
                img_urls.forEach((url) => {
                  if (url.trim() !== "") {
                    imgUrlArr.push(IMAGE_HOST + url.trim());
                  }
                });
                this.info.imgUrl = imgUrlArr;
              } else if (img) {
                let processedUrl = img.replace('imgUrl:"', "").replace('"', "");
                let imgUrlArr1 = [];
                imgUrlArr1.push(IMAGE_HOST + processedUrl);
                this.info.imgUrl = imgUrlArr1;
              }
            }
            if (this.info.sendType == 1) {
              this.sendTypeName = "手动派单";
            } else if (this.info.sendType == 2) {
              this.sendTypeName = "自动派单";
            } else if (this.info.sendType == 3) {
              this.sendTypeName = "抢单派单";
            }
            this.maintainerName = res.data.maintainerName;
            let repairSource = this.info.repairSource;
            let isFastOrder = this.info.isFastOrder;
            this.responseTime = this.computingTime(
              this.info.createTime,
              this.info.receiveTime
            );
            this.handlingTime = this.computingTime(
              this.info.receiveTime,
              this.info.finishTime
            );
            let handlingTime = this.computingTime(
              this.info.createTime,
              this.info.finishTime
            );
            if (
              res.data.state == 3 &&
              this.Pendinglist != null &&
              this.Pendinglist != []
            ) {
              const startSeconds = this.timeToSeconds(handlingTime);
              const endSeconds = this.timeToSeconds(Pendingtime);
              const differenceInSeconds = startSeconds - endSeconds;
              this.handlingTime2 = this.time(differenceInSeconds);
            } else {
              this.handlingTime2 = handlingTime;
            }
            this.text =
              repairSource === 1 && isFastOrder === 0
                ? "扫码报修"
                : repairSource === 1 && isFastOrder === 1
                ? "移动报修"
                : repairSource === 4
                ? "电话报修"
                : repairSource === 3 && isFastOrder === 0
                ? "后台设备报修"
                : repairSource === 3 && isFastOrder === 1
                ? "后台科室报修"
                : repairSource === 2
                ? "维修员"
                : repairSource === 5 && isFastOrder === 1
                ? "用户PC快速"
                : repairSource === 5 && isFastOrder === 0
                ? "用户PC普通"
                : "";
            let maintainerId = this.info.maintainerId;
            let arr2 = res.data.sysWorkSuspensionOrTrackResponseList;
            this.sysWorkTracks = arr2;
            if (arr2.length == 0) {
              this.oldType = this.info.typeName;
            } else {
              for (let i = 0; i < arr2.length; i++) {
                if (arr2[i].originalTypeId != null) {
                  this.loadTypeData(arr2[i].originalTypeId); //初始
                  break;
                } else if (arr2[i].originalTypeId == null) {
                  this.oldType = this.info.typeName;
                }
              }
              this.sysWorkTracks.forEach((item) => {
                console.log(item);
                if (item.imgUrl && item.imgUrl.includes('imgUrl:""')) {
                } else {
                  if (item.imgUrl) {
                    if (item.imgUrl.includes(",")) {
                      let img_urls = item.imgUrl.split(",");
                      let imgUrlArr = [];
                      img_urls.forEach((url) => {
                        if (url.trim() !== "") {
                          imgUrlArr.push(IMAGE_HOST + url.trim());
                        }
                      });
                      item.imgUrl = imgUrlArr;
                    } else {
                      const match = item.imgUrl.match(/imgUrl:"(.+?)"/);
                      const processedUrl = match ? match[1] : item.imgUrl;
                      let imgUrlArr1 = [];
                      imgUrlArr1.push(IMAGE_HOST + processedUrl);
                      item.imgUrl = imgUrlArr1;
                    }
                  }
                }
              });
            }
            for (let i = 0; i < arr2.length; i++) {
              if (arr2[i].originTypeId == "" || arr2[i].originTypeId == null) {
                this.loadTypeData(this.info.typeId);
              }
              if (arr2[i].changeTypeId != null && arr2[i].changeTypeId != 0) {
                this.loadChangeType(arr2[i].changeTypeId); //更改
              }
            }
            let arr = this.info.sysWorks; //协同工单
            if (arr.length > 0) {
              for (let i = 0; i < arr.length; i++) {
                let li = arr[i];
                if (li.maintainerId !== maintainerId) {
                  this.data2.push(li);
                }
              }
            }
            this.id = this.info.id;
          }
        });
        //转单记录
        let q = {};
        q.workId = workId;
        // q.page = page
        q.pageSize = 10;
        q.pageNum = page;
        $utils.api
          .load("/admin/system/transfer/list", q)
          .then((res) => {
            if (res.code > 0) {
              let data = res.rows;
              let list = data || [];
              for (let i = 0; i < list.length; i++) {
                this.oldname = list[i].originalName;
                this.newname = list[i].name;
                this.createTime = list[i].createTime;
                this.updateTime = list[i].updateTime;
                if (list[i].remark == "拒绝转单") {
                  this.block = true;
                  this.remark = "已拒绝";
                } else if (list[i].remark == "接受转单") {
                  this.block = true;
                  this.remark = "已接受";
                } else {
                  this.block = false;
                }
              }
              this.data1 = list;
              this.total = res.total;
            }
          })
          .catch(() => {
            $utils.toast.error("请求错误");
          });
      } else {
        $utils.api.load(`/admin/system/work/call/${callId}`, {}).then((res) => {
          if (res && res.data) {
            if (res.data.imgUrl) {
              this.imgurls = res.data.imgUrl.split(",");
            }
            this.info = res.data;
            if (this.info.sendType == 1) {
              this.sendTypeName = "手动派单";
            } else if (this.info.sendType == 2) {
              this.sendTypeName = "自动派单";
            } else if (this.info.sendType == 3) {
              this.sendTypeName = "抢单派单";
            }
            //转单记录
            let workNo = res.data.workNo;
            let q = {};
            q.workNo = workNo;
            q.pageSize = 10;
            q.pageNum = page;
            $utils.api
              .load("/admin/system/transfer/list", q)
              .then((res) => {
                if (res.code > 0) {
                  let data = res.rows;
                  let list = data || [];
                  this.data1 = list;
                  this.total = res.total;
                }
              })
              .catch(() => {
                $utils.toast.error("请求错误");
              });
          }
        });
      }
    },
    timeToSeconds(timeStr) {
      const timeParts = timeStr.match(/(\d+)时|(\d+)分|(\d+)秒/g); // 匹配时、分、秒
      let totalSeconds = 0;

      if (timeParts) {
        timeParts.forEach((part) => {
          if (part.includes("时")) {
            totalSeconds += parseInt(part) * 3600; // 小时转为秒
          } else if (part.includes("分")) {
            totalSeconds += parseInt(part) * 60; // 分钟转为秒
          } else if (part.includes("秒")) {
            totalSeconds += parseInt(part); // 秒
          }
        });
      }
      return totalSeconds;
    },

    time(time) {
      const hours = Math.floor(time / 3600);
      const minutes = Math.floor((time % 3600) / 60);
      const seconds = time % 60;
      return ` ${hours}小时${minutes}分钟${seconds}秒`;
    },
    calculateTimeDifferences(arr) {
      let totalMilliseconds = 0; // 用于累加总时间差的毫秒数
      const differences = arr.map((item) => {
        const startTime = new Date(item.suspensionTime.replace(" ", "T") + "Z"); // 转换为 ISO 格式
        const endTime = new Date(
          item.suspensionEndTime.replace(" ", "T") + "Z"
        ); // 转换为 ISO 格式
        const differenceInMilliseconds = endTime - startTime; // 计算时间差（毫秒）
        totalMilliseconds += differenceInMilliseconds; // 累加总时间差
      });
      // 汇总总时间差
      const totalHours = Math.floor(totalMilliseconds / (1000 * 60 * 60));
      const totalMinutes = Math.floor(
        (totalMilliseconds % (1000 * 60 * 60)) / (1000 * 60)
      );
      const totalSeconds = Math.floor((totalMilliseconds % (1000 * 60)) / 1000);
      return `${totalHours}小时${totalMinutes}分钟${totalSeconds}秒`;
    },
    previewSrcList(url) {
      var list = [];
      list.push(url);
      return list;
    },
    errorHandler() {
      return true;
    },
    showViewerClose() {
      this.showViewer = false;
    },
    getPreview() {
      this.guidePic
        ? (this.showViewer = true)
        : this.$message.info("当前没有可预览的图片");
    },
    playMusic(type) {
      this.$refs.audio.currentTime = 0; //从头开始播放
      this.$refs.audio.play(); //播放
      setTimeout(() => {
        this.$refs.audio.pause(); //停止
      }, 3000);
    },
    initItems() {
      return this.items;
    },

    async loadTypeData(typeId) {
      // 通过pk查询字典数据
      let res = await $utils.api.load(`/admin/system/workType/${typeId}`);
      if (res && res.code == 200) {
        this.oldType = res.data.name;
        for (let i = 0; i < this.sysWorkTracks.length; i++) {
          let item = this.sysWorkTracks[i];
          if (item.originalTypeId == typeId) {
            item.originalTypeId = res.data.name;
          }
        }
      }
    },
    async loadChangeType(typeId) {
      // 通过pk查询字典数据
      let res = await $utils.api.load(`/admin/system/workType/${typeId}`);
      if (res && res.code == 200) {
        for (let i = 0; i < this.sysWorkTracks.length; i++) {
          let item = this.sysWorkTracks[i];
          if (item.changeTypeId == typeId) {
            item.changeTypeId = res.data.name;
          }
        }
      }
    },
    changePage(p) {
      this.load(this.workId, p);
    },
    showImg(src) {
      this.imgUrl = this.info.qrCode;
      this.imgVisible = true;
    },
    showImgs(src) {
      this.imgVisibles = true;
    },
    //复制工单编号
    copyText() {
      let val = (this.info && this.info.workNo) || "";
      if (this.info && this.info.workNo) {
        let clipboard = new Clipboard("." + val);
        this.$Message.info("已复制工单号：" + val);
      }
    },
    //计算相差时间
    computingTime(a, b) {
      //a开始时间//b结束时间
      var date3 = new Date(b).getTime() - new Date(a).getTime(); //时间差的毫秒数
      //------------------------------
      //计算出相差天数
      // var days = Math.floor(date3 / (24 * 3600 * 1000));
      //计算出小时数
      var leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      var hours = Math.floor(leave1 / (3600 * 1000));
      //计算相差分钟数
      var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      var minutes = Math.floor(leave2 / (60 * 1000));
      //计算相差秒数
      var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      var seconds = Math.round(leave3 / 1000);
      return hours + "时" + minutes + "分" + seconds + "秒";
    },
    //查找设备ID
    async toInfo(num) {
      let q = {
        facilityNum: num,
      };
      let res = await $utils.api.load(`/admin/system/facility/all`, q);
      if (res.code == 200) {
        this.tabledata.push(res.data);
        this.assetNum = res.data.assetNum;
        this.facilityNo = res.data.facilityNum;
        this.assetId = res.data.id;
      }
    },
    //维修记录
    toInfo2(val) {
      $utils.url.push({
        name: "deviceRecordretrieval_list",
        query: { facilityId: val, facilityNo: this.facilityNo },
      });
    },
    toplay(row) {
      let left = (window.screen.width - 300) / 2;
      let top = (window.screen.height - 200) / 3;
      window.open(
        row,
        "_newAutioBox",
        `width=300,height=200,left=${left},top=${top},menubar=no,toolbar=no,status=no,scrollbars=yes`
      );
    },
  },
};
</script>

<style lang="less" scoped>
.workOrder_info {
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: space-between;

  .center {
    width: 80%;

    .elp {
      padding-top: 10px;
      position: fixed;
      top: 110px;
      color: #409eff;
    }

    .elp1 {
      left: 44.875rem;
    }

    .elp2 {
      left: 30.375rem;
    }
  }

  .right {
    color: #000;
    font-size: 13px;
    font-weight: 500;
  }
}

.workOrder_info2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #fff;
  border-radius: 5px;
  position: relative;
  margin-bottom: 10px;
  padding-left: 18px;
  padding-right: 140px;
  /* .left {
    margin-left: 18px;
  }
  .right {
    position: absolute;
    right: 138px;
  } */
}

.workOrder_content {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  background: #fff;
  width: 100%;
  border-radius: 5px;

  .title {
    color: #000;
    font-size: 13px;
    font-weight: 600;
  }

  .item_box {
    display: flex;
  }
}

.workOrder_br {
  height: 1px;
  width: 100%;
  background: #f7f7f7;
}

.common_title {
  color: #000;
  font-size: 13px;
  font-weight: 500;
}

.common_image {
  width: 60px;
  height: 60px;
  border-radius: 2px;
  background: #f7f7f7;
}

.common_image_weixiu {
  width: 60px;
  height: 160px;
  border-radius: 2px;
  background: #fff;
  display: flex;
}

.common_color {
  color: #666;
}

.common_color1 {
  color: orange;
  padding-top: 10px;
}

.common_color2 {
  color: blue;
  padding-top: 10px;
}

.common_color3 {
  color: green;
  padding-top: 10px;
}

.block {
  margin-top: 30px;

  p,
  span {
    font-size: 16px;
  }
}

.divider {
  margin: 0;
}

.bottom {
  margin-top: 20px;
  display: flex;
  justify-content: space-around;

  .Bleft {
    width: 68%;

    .zong {
      margin-top: 10px;
      text-align: right;
    }
  }

  .Bright {
    width: 30%;
  }

  .play {
    color: #409eff;
    cursor: pointer;
  }
}
</style>
